import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 40,
    paddingVertical: 50,
    // justifyContent: 'space-between',
    marginHorizontal: 15,
    marginVertical: 30,
    borderRadius: 8,
    maxWidth: 600,
    alignSelf: 'center',
    width: '100%',
  },
  validation: {
    textAlign: 'center',
    marginTop: 30,
    color: 'black',
  },
  call: {
    textAlign: 'center',
    fontSize: 10,
    fontWeight: '400',
    lineHeight: 15,
    maxWidth: 200,
    alignSelf: 'center',
    marginTop: 30,
  },
  imageBackground: {flex: 1, backgroundColor: '#e61c2b'},
  title: {
    fontSize: 22,
    lineHeight: 26,
    textAlign: 'center',
    color: 'black',
    fontFamily: 'TCCC-UnityText Bold',
    marginTop: 50,
  },
  description: {
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 18,
    textAlign: 'center',
    color: 'gray',
    maxWidth: 210,
    alignSelf: 'center',
    marginBottom: 60,
    marginTop: 5,
  },
  containerInput: {marginBottom: 30},
  containerCheckBox: {alignSelf: 'center', marginTop: 10},
});
